import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacySk5() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`V.`}
            <br />
            {`Trvanie zmluvy`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Zmluva je uzatvorená na dobu neurčitú, pokiaľ nie je výslovne stanovené inak.`}</li>
            <li>{`Zmluvu môže ktorákoľvek zo zmluvných strán vypovedať výpoveďou, a to aj bez uvedenia dôvodu. Výpovedná lehota je 1 mesiac, a začne plynúť od prvého dňa mesiaca nasledujúceho po mesiaci, v ktorom bola výpoveď doručená, a skončí posledným dňom takého mesiaca.`}</li>
            <li>{`Výpoveď môže používateľ podať aj e-mailom z aktuálnej e-mailovej adresy uvedenej v používateľskom účte používateľa, či v rámci používateľského účtu používateľa.`}</li>
            <li>{`Za výpoveď zo strany používateľa sa považuje takisto situácia, keď používateľ neuhradí do 10 dní od konca posledného aktuálne uhradeného predplatiteľského obdobia cenu (alebo jej časť) za službu na ďalšie obdobie. V takom prípade zaniká zmluva uplynutím posledného dňa tejto desaťdennej lehoty.`}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={5} className={sList}>
            <li>{`Používateľ, ktorý je spotrebiteľom, má v súlade s ustanovením § 1829 ods. 1 Občianskeho zákonníka právo od zmluvy odstúpiť, a to do 14 dní od jej uzatvorenia. Odstúpenie od zmluvy musí byť poskytovateľovi odoslané v lehote uvedenej v predchádzajúcej vete.`}</li>
            <li>{`Na odstúpenie od zmluvy môže používateľ využiť vzorový formulár poskytovaný poskytovateľom, ktorý je prílohou týchto obchodných podmienok.`}</li>
            <li>{`Používateľ odoslaním objednávky súhlasí s tým, že poskytovateľ môže začať s poskytovaním služby ihneď po doručení objednávky, a to aj pred uplynutím zákonnej lehoty na odstúpenie od zmluvy. Poskytnutím služby (t. j. digitálneho obsahu) stráca používateľ právo na odstúpenie od zmluvy v období prvých 14 dní od jej uzatvorenia.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacySk5;
